import PropTypes from "prop-types";
import React from "react";
import Alert from "react-bootstrap/Alert";
import { Link } from "react-router-dom";
import { hasLatestFirmware } from "redux-store/devices/selectors";

function DeviceLtsFirmwareWarning() {
  return (
    <Alert variant="warning">
      <i className="fa fa-warning" />
      <span>
        This device is not running the latest certified firmware. This may
        result in undesirable behavior, please update your firmware&nbsp;
        <Link to={`/devices/upgrade/firmware`}>here</Link>.
      </span>
    </Alert>
  );
}

function WrappedDeviceLtsFirmwareWarning(props) {
  if (!hasLatestFirmware(props.device)) {
    return <DeviceLtsFirmwareWarning />;
  }
  return null;
}

WrappedDeviceLtsFirmwareWarning.propTypes = {
  device: PropTypes.object,
};

export { WrappedDeviceLtsFirmwareWarning };
